var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInspectionCampaigns = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9999 2C8.23845 2 5.99987 4.23858 5.99987 7C5.99987 9.76142 8.23845 12 10.9999 12C13.7613 12 15.9999 9.76142 15.9999 7C15.9999 4.23858 13.7613 2 10.9999 2ZM3.99987 7C3.99987 3.13401 7.13388 0 10.9999 0C14.8659 0 17.9999 3.13401 17.9999 7C17.9999 10.866 14.8659 14 10.9999 14C9.47436 14 8.06282 13.512 6.91284 12.6836C6.86817 12.8439 6.7828 12.9953 6.65674 13.1213L2.41121 17.3669C2.02068 17.7574 1.38752 17.7574 0.996995 17.3669C0.606471 16.9763 0.60647 16.3432 0.996995 15.9526L5.24253 11.7071C5.35115 11.5985 5.47854 11.5201 5.61426 11.4719C4.60612 10.2591 3.99987 8.70035 3.99987 7ZM8.85344 6.14645C8.65818 5.95118 8.34159 5.95118 8.14633 6.14645C7.95107 6.34171 7.95107 6.65829 8.14633 6.85355L10.4999 9.2071L13.8534 5.85356C14.0487 5.6583 14.0487 5.34172 13.8534 5.14645C13.6582 4.95119 13.3416 4.95119 13.1463 5.14645L10.4999 7.79289L8.85344 6.14645Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInspectionCampaigns, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inspectionCampaigns.35b6f489.svg";
export { ForwardRef as ReactComponent };